var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 0C5.81775 0 7.5 1.68225 7.5 3.75C7.5 5.81775 5.81775 7.5 3.75 7.5C1.68225 7.5 0 5.81775 0 3.75C0 1.68225 1.68225 0 3.75 0ZM3.75 0.5625C1.99238 0.5625 0.5625 1.99238 0.5625 3.75C0.5625 5.50763 1.99238 6.9375 3.75 6.9375C5.50763 6.9375 6.9375 5.50763 6.9375 3.75C6.9375 1.99238 5.50763 0.5625 3.75 0.5625ZM3.62295 1.91077C3.77857 1.91077 3.9042 2.03677 3.9042 2.19202V3.85028L5.18108 4.61153C5.3142 4.6914 5.35807 4.8639 5.27857 4.9974C5.2257 5.08553 5.13233 5.13465 5.0367 5.13465C4.98758 5.13465 4.93808 5.1219 4.8927 5.09527L3.47895 4.2519C3.3942 4.2009 3.3417 4.10903 3.3417 4.01003V2.19202C3.3417 2.03677 3.4677 1.91077 3.62295 1.91077Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircleGreen);
export default __webpack_public_path__ + "static/media/Time-Circle-Green.d1222d0f5f1ef22f0fd1799e460bc640.svg";
export { ForwardRef as ReactComponent };